// extracted by mini-css-extract-plugin
export default {"categoriesMenu":"DashboardNav_categoriesMenu__YbxZc","dashboardNavItem":"DashboardNav_dashboardNavItem__99svk"};